<template>
    <el-dialog v-model="localVisible" title="Recommended Experts" @close="closeDialog">
      <el-table :data="experts" style="width: 100%">
        <el-table-column prop="name" label="Name" width="180"></el-table-column>
        <el-table-column prop="field" label="Field" width="180"></el-table-column>
        <el-table-column prop="experience" label="Experience" width="180"></el-table-column>
      </el-table>
      <template #footer>
      <el-button @click="closeDialog">Close</el-button>
    </template>
    </el-dialog>
  </template>
  
  <script>
  export default {
    name: 'RecommendedExpertsDialog',
    props: {
      visible: {
        type: Boolean,
        required: true
      },
      experts: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        localVisible: this.visible
      };
    },
    watch: {
      visible(newVal) {
        this.localVisible = newVal;
      },
      localVisible(newVal) {
        this.$emit('update:visible', newVal);
      }
    },
    methods: {
      closeDialog() {
        this.localVisible = false;
      }
    }
  }
  </script>
  